import { AfterViewInit, Component, inject } from '@angular/core';
import { GamificationFacade } from '../../state/gamification.facade';
import { CategoryBadges } from '../../services/models/badges.model';
import anime, { AnimeInstance } from 'animejs';

@Component({
  selector: 'app-gamification-badges',
  templateUrl: './gamification-badges.component.html',
  styleUrls: ['./gamification-badges.component.scss'],
})
export class GamificationBadgesComponent implements AfterViewInit {

  private readonly gamificationFacade = inject(GamificationFacade);

  readonly categoryBadges: CategoryBadges[] = this.gamificationFacade.badges;
  private animateBadgesArray: AnimeInstance[] = [];

  finishedAnimations: number[] = [];

  ngAfterViewInit(): void {
    this.categoryBadges.forEach((_) => this.finishedAnimations.push(-1));

    this.animateBadgesArray = this.categoryBadges.map((_, index) => {
      return anime({
        targets: `.container${index} .badge`,
        opacity: [0, 1],
        translateX: [window.innerWidth, 0],
        easing: 'easeInOutQuad',
        duration: 1000,
        delay: anime.stagger(150),
        direction: 'normal',
        autoplay: false,
        update: (e) => {
          for (let i = 0; i < e.animatables.length; i++) {
            const transform = anime.get(e.animatables[i].target, 'translateX');

            if (transform === '0px') {
              this.finishedAnimations[index] = i;
            }
          }
        },
      });
    });
  }

  onLazyLoad(i) {
    if (!this.animateBadgesArray[i].began) {
      this.animateBadgesArray[i].play();
    }
  }
}
